import { Instance } from 'mobx-state-tree'
import { UserPushNotificationConfigModelBase } from './UserPushNotificationConfigModel.base'

/* The TypeScript type of an instance of UserPushNotificationConfigModel */
export interface UserPushNotificationConfigModelType extends Instance<typeof UserPushNotificationConfigModel.Type> {}

/* A graphql query fragment builders for UserPushNotificationConfigModel */
export {
  selectFromUserPushNotificationConfig,
  userPushNotificationConfigModelPrimitives,
  UserPushNotificationConfigModelSelector
} from './UserPushNotificationConfigModel.base'

/**
 * UserPushNotificationConfigModel
 */
export const UserPushNotificationConfigModel = UserPushNotificationConfigModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
